<div class="ml-7">
  <span>{{'lang.info.redirecting' | translate}}</span>
</div>
